<script>
export default {
    data() {
        return {
            inputPlaceholder: 'Type answer to start quiz',
            quizStarted: false,
            quizQuitted: false,
            quizEnded: false,
            quizTimedOut: false,
            quizCountDown: false,
            hasTimeout: false,
            quizTimeLeft: 0,
            userInput: '',
            correctlyAnswered: [],
            currentScore: 0,
        }
    },
    props: {
        quizOptions: {
            type: Object,
            default(rawProp) {
                return rawProp.quizOptions ? rawProp.quizOptions : {};
            },
            required: false,
        },
    },
    methods: {
        setupQuizData() {
            let component = this;
            if (component.quizOptions) {

                if (component.quizOptions.hasTimeout == true && component.quizOptions.timeoutLimit && component.quizOptions.timeoutType) {
                    component.hasTimeout = true;
                    if (component.quizOptions.timeoutType == 'second') {
                        component.quizTimeLeft = parseInt(component.quizOptions.timeoutLimit);
                    } else if (component.quizOptions.timeoutType == 'minute') {
                        component.quizTimeLeft = parseInt(component.quizOptions.timeoutLimit) * 60;
                    } else if (component.quizOptions.timeoutType == 'hour') {
                        component.quizTimeLeft = (parseInt(component.quizOptions.timeoutLimit) * 60) * 60;
                    }
                }

            }
        },
        onFieldFocus(e) {
            let component = this;
            if (component.quizStarted == false) {
                component.quizStarted = true;
                component.inputPlaceholder = '';
                if (component.hasTimeout && component.quizTimeLeft) {
                    component.quizCountDown = setInterval(function () {
                        // end quiz if all questions have been answered
                        if (component.unAnsweredQuestions.length == 0) {
                            clearInterval(component.quizCountDown);
                            component.endQuiz();
                        } else {

                            // count down logic
                            if (component.quizTimeLeft > 0) {
                                component.quizTimeLeft = parseInt((component.quizTimeLeft - 1));
                            } else {
                                clearInterval(component.quizCountDown);
                                component.quizEnded = true;
                                component.quizTimedOut = true;
                                component.$emit('quiz-timed-out', true);
                                component.endQuiz();
                            }

                        }
                    }, 1000);
                }
                component.$emit('quiz-started', true);
            }
        },
        onUserInput() {
            let component = this;
            let userAnswer = component.userInput || '';
            userAnswer = userAnswer.toLowerCase();
            if (userAnswer && component.unAnsweredQuestions) {
                component.unAnsweredQuestions.forEach(function (question) {
                    let definedAnswers = component.getDefinedAnswers(question);
                    if (definedAnswers.includes(userAnswer)) {
                        component.correctlyAnswered.push(question.id);
                        component.currentScore += parseInt(question.score);
                        component.userInput = '';
                        component.$emit('quiz-score-updated', component.currentScore);
                    }
                });
            }
        },
        isCorrectlyAnswered(questionId) {
            let component = this;
            let result = false;
            if (component.correctlyAnswered.includes(questionId)) {
                result = true;
            }
            return result;
        },
        getDefinedAnswers(question) {
            let definedAnswers = [];
            if (question && (question.answer || (question.answerVariations && question.answerVariations.length))) {
                definedAnswers.push(question.answer.toLowerCase());
                question.answerVariations.forEach(function (variation) {
                    definedAnswers.push(variation.toLowerCase());
                });
            }
            return definedAnswers;
        },
        quitQuiz() {
            let component = this;
            component.quizQuitted = true;
            component.$emit('quiz-quitted', true);
            component.endQuiz();
        },
        endQuiz() {
            let component = this;
            component.quizEnded = true;
            component.$emit('quiz-ended', true);
        },
        onChallengeFriend() {
            console.log('onChallengeFriend')
        },
        sortedQuizQuestions() {
            let component = this;
            let sortedQuestions = [];
            if (component.quizOptions && component.quizOptions.questions && component.quizOptions.questions.length) {
                sortedQuestions = component.quizOptions.questions.sort(function (a, b) {
                    if (a.order > b.order) {
                        return 1;
                    } else if (a.order < b.order) {
                        return -1;
                    } else {
                        return 0;
                    }
                });
            }
            return sortedQuestions;
        }
    },
    computed: {
        unAnsweredQuestions() {
            let questions = [];
            let component = this;
            if (component.quizOptions.questions && component.quizOptions.questions.length) {
                component.quizOptions.questions.forEach(function (question) {
                    if (!component.isCorrectlyAnswered(question.id)) {
                        questions.push(question);
                    }
                });
            }
            return questions;
        },
        totalScore() {
            let totalScore = 0;
            let component = this;
            if (component.quizOptions.questions && component.quizOptions.questions.length) {
                component.quizOptions.questions.forEach(function (question) {
                    totalScore += parseInt(question.score);
                });
            }
            return totalScore;
        },
        layout() {
            return this.getQuizLayout(this.quizOptions);
        },
        gridStyle() {
            if (this.layout.sections) {
                return { display: 'flex', alignItems: 'flex-start', gap: '0 10px' };
            }
            return { display: 'grid', gridTemplateColumns: `repeat(${this.layout.columns}, 1fr)` };
        },
    },
    mounted() {
        let component = this;
        component.setupQuizData();
    }
}
</script>
<template>
    <div class="aktion-quiz aktion-quiz-guess-answers">
        <div class="quiz-header">
            <div v-if="quizEnded == false" class="quiz-header-elements">
                <div class="quiz-input-wrap">
                    <input class="user-input" :placeholder="inputPlaceholder" @focus="onFieldFocus" @input="onUserInput" v-model="userInput" type="text" autocomplete="off"/>
                </div>
                <div class="quiz-score-wrap">
                    <label class="quiz-data-label" for="current-quiz-score">Score:</label>
                    <p class="quiz-data-text" id="current-quiz-score"><span>{{ currentScore }}</span>/<span>{{ totalScore }}</span></p>
                </div>
                <div class="quiz-time-wrap" v-if="quizOptions.hasTimeout">
                    <label class="quiz-data-label" for="current-quiz-time">Time:</label>
                    <p class="quiz-data-text" id="current-quiz-time"><span>{{ secondsToMinSecPadded(quizTimeLeft) }}</span></p>
                </div>
                <div class="quiz-actions-wrap">
                    <button class="quiz-action-btn" v-if="quizStarted == false" type="button" @click="$emit('open-challenge-modal')">Challenge a Friend</button>
                    <button class="quiz-action-btn" v-else type="button" @click="quitQuiz">Quit & See Answers</button>
                </div>
            </div>
            <div v-else class="quiz-final-score">
                <p>Your score: <span>{{ currentScore }}</span> out of <span>{{ totalScore }}</span></p>
            </div>
        </div>
        <div class="quiz-question-grid" :class="{ 'quiz-ended': quizEnded, 'quiz-timed-out': quizTimedOut, 'quiz-quitted': quizQuitted }" :style="gridStyle" v-if="quizOptions.questions && quizOptions.questions.length">
            <template v-if="layout.sections">
                <div class="quiz-section-column" v-for="(section, si) in layout.sections" :key="'section-' + si" :style="{ flex: '1', display: 'flex', flexDirection: 'column', minWidth: '0' }">
                    <div class="quiz-section-title" v-if="section.label">{{ section.label }}</div>
                    <div class="quiz-grid-item" :class="{ 'is-correct': isCorrectlyAnswered(question.id) }" v-for="question in section.questions" :key="question.id">
                        <div class="quiz-question-label">
                            <span>{{ question.label }}</span>
                        </div>
                        <div class="quiz-question-answer" v-if="isCorrectlyAnswered(question.id) || quizEnded">
                            <span>{{ question.answer }}</span>
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <div class="quiz-grid-item" :class="{ 'is-correct': isCorrectlyAnswered(question.id) }" v-for="(question, index) in sortedQuizQuestions()" :key="question.id">
                    <div class="quiz-question-label">
                        <span>{{ question.label }}</span>
                    </div>
                    <div class="quiz-question-answer" v-if="isCorrectlyAnswered(question.id) || quizEnded">
                        <span>{{ question.answer }}</span>
                    </div>
                </div>
            </template>
        </div>
    </div>
</template>